import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "t-h1 h-100 f f-center-center"
}

import { useStore } from "vuex";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingBlock',
  props: {
    path: String,
    isLoading: Boolean,
},
  setup(__props) {

const props = __props;

const store = useStore();



const loadingPath = computed(() => store.getters.apiLoadingPath);
const isLoadingPath = computed(() => loadingPath.value === props.path);

return (_ctx: any,_cache: any) => {
  const _component_SpinnerIcon = _resolveComponent("SpinnerIcon")!

  return (__props.isLoading || _unref(isLoadingPath))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SpinnerIcon)
      ]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})